module.exports = __webpack_public_path__ + "static/media/IconMarkerActive.1856d2fa.svg";